import { BASE_URL } from "config";
import * as baseApi from "./_base";

export const endpoints = {
    list: `${BASE_URL}/api/v1/seo/template/page/`,
    detail: (id) => `${BASE_URL}/api/v1/seo/template/page/${id}/`,
};

export const seoTemplatePageLoad = (token, payload) => baseApi.ListLoad(endpoints.list, token, payload);
export const seoTemplatePageDetailLoad = (token, { id }) => baseApi.DetailLoad(endpoints.detail, token, { id });
export const seoTemplatePageUpdate = (token, data) => baseApi.Update(endpoints.list, endpoints.detail, token, data);
export const seoTemplatePageDelete = (token, { id }) => baseApi.Delete(endpoints.detail, token, { id });
